document.addEventListener('DOMContentLoaded', function() {
  let isDesktop = window.innerWidth >= 750;
  
  // Función para verificar si estamos en desktop
  function checkIfDesktop() {
    return window.innerWidth >= 750;
  }
  
  // Función para intercambiar las primeras dos imágenes del producto
  function swapProductImages() {
    isDesktop = checkIfDesktop();
    
    if (isDesktop) {
      // DESKTOP: Intercambiar posiciones físicas en el DOM
      swapDesktopImages();
    } else {
      // MOBILE: Solo cambiar la imagen activa sin mover el DOM
      swapMobileImages();
    }
  }
  
  // Función para desktop (intercambiar físicamente)
  function swapDesktopImages() {
    const galleryList = document.querySelector('.product__media-list');
    
    if (!galleryList) return;
    
    const slides = galleryList.querySelectorAll('.product__media-item');
    
    if (slides.length < 2) return;
    
    const firstSlide = slides[0];
    const secondSlide = slides[1];
    
    // Verificar si ya están intercambiados
    if (firstSlide.dataset.swapped === 'true') return;
    
    // Intercambiar posiciones en el DOM
    galleryList.insertBefore(secondSlide, firstSlide);
    
    // Marcar como intercambiado
    firstSlide.dataset.swapped = 'true';
    secondSlide.dataset.swapped = 'true';
    
    // Actualizar clases is-active
    firstSlide.classList.remove('is-active');
    secondSlide.classList.add('is-active');
    
    // Actualizar miniaturas
    const thumbnailList = document.querySelector('.thumbnail-list');
    if (thumbnailList) {
      const thumbnails = thumbnailList.querySelectorAll('.thumbnail-list__item');
      if (thumbnails.length >= 2) {
        thumbnailList.insertBefore(thumbnails[1], thumbnails[0]);
        
        const firstButton = thumbnails[0].querySelector('button');
        const secondButton = thumbnails[1].querySelector('button');
        
        if (firstButton) firstButton.removeAttribute('aria-current');
        if (secondButton) secondButton.setAttribute('aria-current', 'true');
      }
    }
    
    // Actualizar contador
    const counter = document.querySelector('.slider-counter--current');
    if (counter) counter.textContent = '1';
  }
  
  // Función para mobile (solo cambiar imagen activa)
  function swapMobileImages() {
    const sliderComponent = document.querySelector('slider-component');
    
    if (!sliderComponent) return;
    
    const slider = sliderComponent.querySelector('.slider');
    if (!slider) return;
    
    const slides = slider.querySelectorAll('.slider__slide');
    
    if (slides.length < 2) return;
    
    // NO intercambiar el DOM, solo navegar al segundo slide
    const secondSlide = slides[1];
    
    // Encontrar el slideshow component
    if (sliderComponent && typeof sliderComponent.slider !== 'undefined') {
      // Usar el método del slider para ir al slide 2
      sliderComponent.slider.scrollTo({
        left: secondSlide.offsetLeft,
        behavior: 'instant'
      });
    } else {
      // Fallback: scroll manual
      slider.scrollTo({
        left: secondSlide.offsetLeft,
        behavior: 'instant'
      });
    }
    
    // Actualizar contador si existe
    const counter = document.querySelector('.slider-counter--current');
    if (counter) counter.textContent = '2';
    
    // Actualizar botones de navegación
    const thumbnailButtons = document.querySelectorAll('.thumbnail-list__item button, .slider-counter__link');
    thumbnailButtons.forEach((btn, index) => {
      if (index === 1) {
        btn.setAttribute('aria-current', 'true');
        btn.classList.add('slider-counter__link--active');
      } else if (index === 0) {
        btn.removeAttribute('aria-current');
        btn.classList.remove('slider-counter__link--active');
      }
    });
  }
  
  // Ejecutar al cargar la página
  setTimeout(swapProductImages, 200);
  
  // Ejecutar cuando cambie la variante
  document.addEventListener('variant:change', function() {
    setTimeout(swapProductImages, 200);
  });
  
  // Ejecutar cuando cambie el tamaño de la ventana
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      const newIsDesktop = checkIfDesktop();
      if (newIsDesktop !== isDesktop) {
        // Recargar la página si cambiamos entre mobile y desktop
        location.reload();
      }
    }, 250);
  });
});